import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CreateDiamondPackages,
  CreateHostLevel,
  CreateSenderLevel,
  uploadFile,
} from "../../DAL/create";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { GetDiamondsPackageByIdList } from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import { updateDiamondsPackage } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";
export const EditPackages = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [inputs, setInputs] = useState({
    amount: "",
    diamonds: "",
    image: "",
    tag: "",
    original: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [type, setType] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageUpload = async (e) => {
    const value = e.target.files[0];
    const formData = new FormData();
    formData.append("image", value);
    const resp = await uploadFile(formData);
    setPreviewImage(URL.createObjectURL(value));
    setInputs((prev) => ({ ...prev, image: resp?.data?.url }));
  };

  const FetchSingleDetail = async () => {
    const resp = await GetDiamondsPackageByIdList(params?.id);
    if (resp?.status == 200) {
      setInputs({
        amount: resp?.data?.amount,
        diamonds: resp?.data?.diamond,
        image: resp?.data?.pictureUrl,
        tag: resp?.data?.tag,
        original: resp?.data?.original,
      });
      setPreviewImage(fileUrl + resp?.data?.pictureUrl);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputs?.amount) {
      setType(true);
      return;
    }
    if (!inputs?.diamonds) {
      setType(true);
      return;
    }
    if (!inputs?.original) {
      setType(true);
      return;
    }
    if (inputs?.diamonds < 1) {
      enqueueSnackbar('Diamonds cannot be less than 1');
      return
    }
    if (inputs?.amount >= inputs?.original) {
      enqueueSnackbar("Discounted amount must be less than the original amount", {
        variant: "error",
      });
      return;
    }
    const data = {
      amount: Number(inputs?.amount),
      tag: inputs?.tag,
      original: Number(inputs?.original),
      diamond: Number(inputs?.diamonds),
      pictureUrl: inputs?.image,
    };
    const resp = await updateDiamondsPackage(params?.id, data);
    if (resp?.status == 200) {
      enqueueSnackbar("Diamond package updated successfully", {
        variant: "success",
      });
      navigate("/diamonds-packages");
    } else {
      enqueueSnackbar("Error while update Diamond package", {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    FetchSingleDetail();
  }, []);
  return (
    <>
      <div className="mainDiv">
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/diamonds-packages")}
          />
          <Typography variant="h6">Edit Diamonds Packages</Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "6px" }}>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Diamonds *"
              type="number"
              value={inputs?.diamonds}
              name="diamonds"
              onChange={(e) =>
                setInputs((prev) => ({
                  ...prev,
                  ["diamonds"]: e.target.value < 0 ? 0 : e.target.value,
                }))
              }
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true &&
                inputs?.diamonds == "" &&
                "Diamond field is required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Original Amount *"
              type="number"
              value={inputs?.original}
              name="original"
              onChange={handleChange}
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true &&
                inputs?.original == "" &&
                "Original field is required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Discounted Amount *"
              type="number"
              value={inputs?.amount}
              name="amount"
              onChange={handleChange}
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true &&
                inputs?.amount == "" &&
                "Discounted amount field is required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={12} sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(to right, #5301d7, #008eca)",
                color: "white",
                textTransform: "none",
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
